"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var channel_1 = require("./channel");
var Channels = /** @class */ (function () {
    function Channels(virtualSocket) {
        this.virtualSocket = virtualSocket;
        this.channelsList = {};
    }
    Channels.prototype.add = function (channelName, opts) {
        return (this.channelsList[channelName] =
            this.channelsList[channelName] ||
                new channel_1.default(this.virtualSocket, channelName, opts));
    };
    Channels.prototype.remove = function (channelName) {
        var channel = this.find(channelName);
        delete this.channelsList[channelName];
        return channel;
    };
    Channels.prototype.find = function (channelName) {
        return this.channelsList[channelName];
    };
    Channels.prototype.all = function () {
        var _this = this;
        return Object.keys(this.channelsList).map(function (channelName) {
            return _this.find(channelName);
        });
    };
    Channels.prototype.forceSubscribeAll = function () {
        this.all().forEach(function (c) { return c.forceSubscribe(); });
    };
    return Channels;
}());
exports.default = Channels;
//# sourceMappingURL=channels.js.map